import { Error } from '../../../../../../ErrorHandling';
import { InvitationResource } from '../Types';

export type InvitationStatus = 'active' | 'inactive';

interface SuccessState {
  resource: InvitationResource;
  invitationStatus: InvitationStatus;
}

export interface Waiting {
  kind: 'waiting';
}

export interface ConfirmingDeactivate {
  kind: 'confirming-deactivate';
  invitationStatus: 'inactive';
  resource: InvitationResource;
}

export interface Deactivating {
  kind: 'deactivating';
  invitationStatus: 'inactive';
  resource: InvitationResource;
}

export interface Reactivating {
  kind: 'reactivating';
  invitationStatus: 'active';
  resource: InvitationResource;
}

export interface DeactivateSucceeded extends SuccessState {
  kind: 'deactivate-succeeded';
}

export interface ReactivateSucceeded extends SuccessState {
  kind: 'reactivate-succeeded';
}

export const waiting = (): Waiting => ({
  kind: 'waiting',
});

export const confirmingDeactivate = (resource: InvitationResource): ConfirmingDeactivate => ({
  kind: 'confirming-deactivate',
  invitationStatus: 'inactive',
  resource,
});

export const deactivating = (state: ConfirmingDeactivate): Deactivating => {
  const { kind, ...previous } = state;
  return {
    kind: 'deactivating',
    ...previous,
    invitationStatus: 'inactive',
  };
};

export const reactivating = (resource: InvitationResource): Reactivating => ({
  kind: 'reactivating',
  invitationStatus: 'active',
  resource,
});

export const deactivateSucceeded = (
  resource: InvitationResource,
  state: Deactivating,
): DeactivateSucceeded => {
  const { kind, ...previous } = state;
  return {
    kind: 'deactivate-succeeded',
    ...previous,
    resource,
  };
};

export const reactivateSucceeded = (
  resource: InvitationResource,
  state: Reactivating,
): ReactivateSucceeded => {
  const { kind, ...previous } = state;
  return {
    kind: 'reactivate-succeeded',
    ...previous,
    resource,
  };
};

export type State =
  | Waiting
  | ConfirmingDeactivate
  | Deactivating
  | DeactivateSucceeded
  | Reactivating
  | ReactivateSucceeded
  | Error;
